import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { insightsHeader, Octopus } from '@maximizer/core/shared/domain';
import { map, Observable } from 'rxjs';
import { ContextService } from './context.service';

@Injectable()
export class InteractionLogService {
  constructor(
    private readonly context: ContextService,
    private readonly httpClient: HttpClient,
  ) {}

  delete(interactionLogkeys: string[]): Observable<boolean> {
    const request: { [name: string]: unknown } = {};

    if (interactionLogkeys) {
      interactionLogkeys.forEach(
        (key, index) =>
          (request['InteractionLog.' + index] = { Data: { Key: key } }),
      );
    }

    return this.httpClient
      .post<Octopus.Response>(
        `${this.context.api}${Octopus.Action.DELETE}`,
        request,
        { headers: this.getRequestHeaders() },
      )
      .pipe(
        map((result) => {
          return result.Code === Octopus.ResponseStatusCode.Successful;
        }),
      );
  }
  private getRequestHeaders(): { [header: string]: string } {
    return {
      [insightsHeader('entity')]: 'InteractionLog',
    };
  }
}
